import type { ServiceLabel } from './types';

/** Singapore is single-service-only per the legacy config. Extend as needed. */
export const SINGAPORE_SERVICES: readonly ServiceLabel[] = [
  { key: 'Other', label: 'Other', jurisdiction: 'Singapore' },
] as const;